import { MessagePanel } from 'view-layer/components/layout';
import { fetch, fetchInstance, abortController } from 'data-layer/fetch-api/fetch';
import { useDocumentTitle } from 'business-layer/hooks/useDocumentTitle';
import { useTimer } from 'business-layer/hooks/useTimer';
import { sprintf } from 'business-layer/helpers/sprintf';
import { PaymentStatusSerivce } from 'data-layer/services/PaymentStatusSerivce';
import { useParams, useNavigate  } from 'react-router-dom';
import { CardPaymentProcessing } from 'view-layer/components/layout/statuses/CardPaymentProcessing';
import { LayoutContainer } from 'view-layer/components/layout/LayoutContainer';
import useFetch, { FetchResult } from 'data-layer/fetch-api/useFetch';
import { PaymentRequestService } from 'data-layer/services/PaymentRequestService';
import { PaymentDataDto } from 'data-layer/dto';

import { Loader } from 'view-layer/components/common';

const ReqLimit = 3;
const ReqDelay = 2000;

const ResponseStatus: Record<string, string> = {
  successful: '/payment/%1/completed',
  declined: '/payment/%1/declined',
  failed: '/payment/%1/declined',
}

export const Processing = (props: any) => {
  useDocumentTitle('Processing your payment...');
  const navigate = useNavigate();
  const { hash: payByLinkId = '', payment: paymentHash = '' } = useParams();

  const [ data, loading, error ]: FetchResult<PaymentDataDto> = useFetch(PaymentRequestService(payByLinkId), PaymentDataDto, payByLinkId);

  const {url, data: postData = null, method = 'POST' } = PaymentStatusSerivce({ payByLinkId, paymentHash });

  useTimer(
    () => {
      (async () => {
        try {
          const { data: responseData } = await fetch(
            fetchInstance,
            url,
            postData,
            { signal: abortController.signal, method, },
          );
          if (!responseData.success) {
            throw new Error(responseData.message || 'Server returned error.');
          }

          const redirect = ResponseStatus[responseData.data?.status];
          const { cardholderName } = responseData.data;

          if (redirect) {
            const url = sprintf(redirect!, payByLinkId);
            navigate(url, { state: { cardholderName }});
          }
        } catch (err) {
          // const message = (err as any).message || 'We are sorry, but we can\'t fulfill your request at the moment.'
          // navigate('/error', { state: { message }});
        }
      })();

    },
    ReqDelay,
    ReqLimit,
  )

  if (loading) {
    return (
      <Loader />
    );
  }
  if (data === null) {
    return <></>;
  }

  if (!!error) {
    return <MessagePanel message={error} />;
  }

  return (
    <LayoutContainer payment={{ ...data?.payment, ...data?.property}}>
      <CardPaymentProcessing />
    </LayoutContainer>
  )
}
